import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from 'models/Provider';
import { Button } from 'components/Button';
import { ModalActions, ModalHeader, ModalText } from 'components/Modal';
import { Loading } from 'components/Loading';

function RetractApplicantModal({ applicant, closeModal }) {
  const [submitting, setSubmitting] = useState(false);
  const { t } = useStore();

  function onSubmit() {
    setSubmitting(true);
    const success = applicant.retract();
    if (success) {
      closeModal();
    } else {
      setSubmitting(false);
    }
  }
  return (
    <>
      <ModalHeader>{t('retractmodal.title')}</ModalHeader>
      <ModalText as="p">
        {t('retractmodal.confirmtext')} <strong>{applicant.name}</strong>?
      </ModalText>
      {submitting && <Loading />}

      <ModalActions>
        <Button disabled={submitting} gray onClick={closeModal}>
          {t('retractmodal.button.cancel')}
        </Button>
        <Button disabled={submitting} onClick={onSubmit}>
          {t('retractmodal.button.submit')}
        </Button>
      </ModalActions>
    </>
  );
}

export default observer(RetractApplicantModal);
